import { CcLibraryItem, CcLibraryItemList } from "server/models"
import { inferLiteral } from "client/utils"
import { TableGroupedIds } from "client/components"
import * as types from "./types"


export const setCcLibraryItemList = (itemList: CcLibraryItemList) => ({
    type: inferLiteral(types.CC_LIBRARY_ITEM_LIST),
    itemList,
})
export const setCcLibraryItemNested = (itemGroupedIds: TableGroupedIds) => ({
    type: inferLiteral(types.CC_LIBRARY_ITEM_NESTED),
    itemGroupedIds,
})
export const setCcLibraryItemView = (item: CcLibraryItem) => ({
    type: inferLiteral(types.CC_LIBRARY_ITEM_VIEW),
    item,
})
export const setCcLibraryItemEdit = (item: CcLibraryItem) => ({
    type: inferLiteral(types.CC_LIBRARY_ITEM_EDIT),
    item,
})
export const setCcLibraryItemReloadList = (value: boolean) => ({
    type: inferLiteral(types.CC_LIBRARY_ITEM_RELOAD_LIST),
    value,
})
export const setCcLibraryItemReloadView = (value: boolean) => ({
    type: inferLiteral(types.CC_LIBRARY_ITEM_RELOAD_VIEW),
    value,
})
export const setCcLibraryItemReloadEdit = (value: boolean) => ({
    type: inferLiteral(types.CC_LIBRARY_ITEM_RELOAD_EDIT),
    value,
})
export const setCcLibraryItemParents = (parentItemId: number, parentHeadingId: number) => ({
    type: inferLiteral(types.CC_LIBRARY_ITEM_PARENTS),
    parentItemId,
    parentHeadingId,
})
export const setCcLibraryItemAvailableParents = (parents: CcLibraryItem[]) => ({
    type: inferLiteral(types.CC_LIBRARY_ITEM_AVAILABLE_PARENTS),
    parents,
})
export const setCcLibraryItemAvailableParentsFiltered = (parentsFiltered: CcLibraryItem[]) => ({
    type: inferLiteral(types.CC_LIBRARY_ITEM_AVAILABLE_PARENTS_FILTERED),
    parentsFiltered,
})
export const setCcLibraryItemAvailableParentSearch = (search: string) => ({
    type: inferLiteral(types.CC_LIBRARY_ITEM_AVAILABLE_PARENT_SEARCH),
    search,
})
export const setCcLibraryItemMenu = (
    targetId: number,
    targetElement: HTMLElement,
) => ({
    type: inferLiteral(types.CC_LIBRARY_ITEM_MENU),
    targetId,
    targetElement,
})
export const setCcLibraryItemConfirmDelete = (item: CcLibraryItem) => ({
    type: inferLiteral(types.CC_LIBRARY_ITEM_CONFIRM_DELETE),
    item,
})
